import React from 'react';

interface Props {
  country?: string;
}

const Terms = ({ country }: Props) => (
  <>
    {country === 'BR' && (
      <>
        <div>
          <div>
            <h4>Condições Gerais</h4>
            <ul>
              <li>
                A RAPPI AGENCIA DE VIAGENS E TURISMO LTDA empresa com sede social na Av dos Autonomistas, 896, bloco
                torre 1 conjunto 1211 setor parte, Osasco/SP, CEP. CEP 06.020-010, devidamente inscrita no CNPJ/MF sob o
                n° 35.506.356/0001-86 , que para os efeitos destes termos e condições serão denominados &quot;Rappi
                Travel&quot;.
              </li>
              <li>
                <b>Natureza jurídica.</b>
                <br />
                Estes termos e condições regulam a utilização do Serviço NetViajes Travel Corporate, através do qual o
                Cliente pode, entre outros: i) efetuar compras de Serviços de viagens corporativas ; ii) determinar os
                perfis de acesso (Viajante, Administrador e/ou Aprovador) dos Beneficiários; iii) determinar as
                condições de consumo e as limitações aplicáveis à aquisição e fruição dos Serviços de Turismo pelas
                Beneficiárias; iv) definir as políticas de viagens aplicáveis à utilização do NetViajes Travel Corporate
                Service pelos Beneficiários; ev) adicionar e/ou modificar as formas de pagamento para aquisição de
                Serviços de viagens corporativas pelos Beneficiários
              </li>
              <li>
                O Cliente aceita estes termos e condições e não poderá fazer modificações nos mesmos, entendendo que a
                partir do momento da aceitação, a utilização do Serviço NetViajes Travel Corporate será objeto único de
                regulamentação. Esclarece-se que estes termos e condições não modificam qualquer tipo de contrato
                previamente firmado entre as Partes que tenha finalidade diversa daquela aqui prevista.
              </li>
              <li>
                <b>Definições</b>
                <br />
                <b>Beneficiários.</b> Pessoa física que está autorizada pelo Cliente a adquirir Serviços de viagens
                corporativas, às custas do Cliente, de acordo com i) o perfil que detém (Viajante, Administrador e/ou
                Aprovador) no Serviço NetViajes Travel Corporate e, ii) as políticas de viagens definidas pelo Cliente
                e/ou Beneficiários com Perfil de Administrador.
                <br />
                <b>Cliente.</b> Pessoa jurídica que adquire o NetViajes Travel Corporate Service.
                <br />
                <b>Botão NetViajes Travel Corporate.</b> Espaço disponibilizado na Plataforma, onde são exibidos os
                Serviços de viagens corporativas que podem ser adquiridos pelos Beneficiários. Esclarece-se que o nome
                do botão pode ser alterado a qualquer momento pelo Rappi, entendendo que esta definição se refere à
                funcionalidade e não ao nome específico.
                <br />
                <b>Lei aplicável.</b> A lei aplicável para todos os fins destes termos e condições será a lei
                brasileira.
                <br />
                <b>Pessoa.</b> Significa qualquer pessoa física, jurídica, parceria, truste, consórcio, parceria
                irregular, associação ou qualquer entidade com personalidade jurídica própria, nos termos da Legislação
                Aplicável.
                <br />
                <b>Plataforma.</b> Plataforma virtual, composta por uma aplicação para dispositivos móveis e uma página
                web, através da qual são apresentados produtos e serviços de terceiros para que possam ser adquiridos
                pelos Usuários / Consumidores
                <br />
                <b>Perfil do viajante.</b> Beneficiários que estejam autorizados pelo Cliente a solicitar Serviços de
                viagens corporativas através do NetViajes Travel Corporate, à custa do Cliente. Esclarece-se que a
                compra efetiva dos Serviços solicitada pelo Beneficiário com Perfil de Viajante poderá estar sujeita às
                aprovações aplicáveis ao referido Beneficiário com Perfil de Viajante, de acordo com as políticas de
                viagens definidas pelo Cliente e/ou Beneficiários com Perfil de Administrador
                <br />
                <b>Perfil de administrador.</b> Beneficiários autorizados pelo Cliente a: i) solicitar Serviços de
                viagens corporativas em seu próprio nome ou em nome de outros Beneficiários, às custas do Cliente; ii)
                definir e/ou modificar os perfis dos Beneficiários do NetViajes Travel Corporate Service; iii) adicionar
                ou modificar os métodos de pagamento registrados no NetViajes Travel Corporate Service; iv) convidar
                novos Beneficiários e definir seu perfil; v) fornecer e/ou modificar as políticas de viagens do Cliente;
                e vi) cadastrar orçamentos de acordo com as necessidades do Cliente.
                <br />
                <b> Perfil do aprovador.</b> Beneficiários que estejam autorizados pelo Cliente a aprovar solicitações
                de viagens feitos por outros Beneficiários, de acordo com as políticas de viagens definidas pelo Cliente
                e/ou Beneficiários com Perfil de Administrador.
                <br />
                <b>NetViajes Travel Corporate Service.</b> Serviço prestado pela Netactica Corporate ao Cliente através
                do Botão NetViajes Travel Corporate dentro da Plataforma e através do site https://NetViajes Travel
                Corporate.rappi.com/, que permite ao Cliente: i) efetuar compras de Serviços de viagens corporativas ;
                ii) determinar os perfis de acesso (Viajante, Administrador e/ou Aprovador) dos Beneficiários; iii)
                determinar as condições de consumo e as limitações aplicáveis à aquisição e fruição dos Serviços de
                viagens pelas Beneficiárias; iv) definir as políticas de viagens aplicáveis à utilização do NetViajes
                Travel Corporate Service pelos Beneficiários; e v) adicionar e/ou modificar as formas de pagamento para
                aquisição de Serviços Turísticos pelos Beneficiários.
                <br />
                <b>Serviços de viagens corporativas.</b> Serviços como reservas de hospedagens, passagens aéreas, entre
                outros, expostos, oferecidos e comercializados por terceiros prestadores de Serviços através do Botão
                NetViajes Travel Corporate.
                <br />
                <b> Usuários/Consumidores.</b> Qualquer pessoa física que, como destinatário final, utilize a Plataforma
                para adquirir e usufruir dos produtos e serviços de consumo nela exibidos.
              </li>
            </ul>
            <h3>1. Objeto</h3>
            <ul>
              <li>
                {' '}
                Estes termos e condições regulam as condições de utilização do NetViajes Travel Corporate através do
                qual o Cliente pode, entre outros: i) efetuar compras de Serviços de viagens corporativas; ii)
                determinar os perfis de acesso (Viajante, Administrador e/ou Aprovador) dos Beneficiários; iii)
                determinar as condições de consumo e as limitações aplicáveis à aquisição e fruição dos Serviços de
                viagens pelas Beneficiárias; iv) definir as políticas de viagens aplicáveis à utilização do NetViajes
                Travel Corporate Service pelos Beneficiários; ev) adicionar e/ou modificar as formas de pagamento para
                aquisição de Serviços Turísticos pelos Beneficiários
              </li>
            </ul>
            <h3>2. Aplicação.</h3>
            <ul>
              <li>
                {' '}
                Estes termos e condições serão aplicáveis ao Cliente, desde que ele use o Serviço NetViajes Travel
                Corporate. Desta forma, todas as interações e uso geral feito pelo Cliente e/ou Beneficiários do Serviço
                NetViajes Travel Corporate serão regidos por estes termos e condições
              </li>
            </ul>
            <h3>3. Aceitação dos Termos e Condições.</h3>
            <ul>
              <li>
                {' '}
                A pessoa física que aceita estes termos e condições declara e garante ter poderes suficientes para
                representar e obrigar o Cliente a cumprir o que aqui se estabelece.
              </li>
            </ul>
            <h3>4. Independência das Partes</h3>
            <ul>
              <li>
                {' '}
                Entende-se que a Netactica Corporate e o Cliente são independentes e autônomos. Desta forma, tanto a
                Netactica Corporate como o Cliente cumprirão com suas obrigações perante terceiros nas áreas trabalhista,
                previdenciária e fiscal, de forma independente.
              </li>
            </ul>
            <h3>5. Gerenciamento de contas</h3>
            <ul>
              <li>
                {' '}
                O Cliente terá total liberdade e autonomia para administrar sua conta no Serviço NetViajes Travel
                Corporate, entendendo que será o único responsável pelos atos com ela realizados. Em virtude da referida
                autonomia e independência, Netactica Corporate não se responsabiliza pelas ações e/ou omissões dos
                Beneficiários, pelas condições de consumo e/ou limitações estabelecidas pelo Cliente e/ou pelos
                Beneficiários com Perfil de Administrador, e/ou por o manuseio ou uso de cartões de crédito ou débito
                registrados no NetViajes Travel Corporate Service. Desta forma, o Cliente ou os Beneficiários com Perfil
                de Administrador, serão os únicos que poderão acessar para ativar, administrar, operar e, em geral,
                administrar a conta do Cliente dentro do NetViajes Travel Corporate Service, liberando Netactica
                Corporate para qualquer uso não reconhecido que é feito nele. Em virtude do exposto, o Cliente isentará
                a Netactica Corporate de qualquer reclamação, dano, dano e/ou sanção gerada à Netactica Corporate e/ou
                terceiros em relação ao uso da conta do Cliente no Serviço NetViajes Travel Corporate.
              </li>
            </ul>
            <h3>6. Vinculando Beneficiários</h3>
            <ul>
              <li>
                {' '}
                Através do NetViajes Travel Corporate Service, o Cliente poderá determinar os Beneficiários com Perfil
                de Administrador, entendendo que este (s) será (m) quem: i) convidará Beneficiários e; ii) definir e/ou
                modificar os perfis dos Beneficiários do NetViajes Travel Corporate Service.
              </li>
            </ul>
            <h3>7. Aprovação de Serviços de Turismo</h3>
            <ul>
              <li>
                {' '}
                Por meio do Serviço NetViajes Travel Corporate, Beneficiários com Perfil Aprovador são aqueles que estão
                autorizados pelo Cliente a aprovar solicitações de viagens feitas por outros Beneficiários, de acordo
                com as políticas de viagens definidas pelo Cliente e/ou Beneficiários com Perfil Administrador. Desta
                forma, os Beneficiários que, de acordo com a política de viagens requerem aprovação, só poderão adquirir
                os Serviços de viagens corporativas solicitados através do NetViajes Travel Corporate, com prévia
                autorização do Beneficiário com o Perfil de Aprovação
              </li>
            </ul>
            <h3>8. Condições de consumo.</h3>
            <ul>
              <li>
                {' '}
                Através do NetViajes Travel Corporate Service, o Cliente e/ou Beneficiários com Perfil de Administrador
                podem definir as condições de consumo e as limitações que se aplicam à aquisição e fruição dos Serviços
                pelos Beneficiários. Esclarece-se que as referidas condições e limitações deverão ser selecionadas pelo
                Cliente e/ou pelo (s) Beneficiário (s) com Perfil de Administrador, conforme o caso, de acordo com as
                opções oferecidas pelo NetViajes Travel Corporate Service.
              </li>
            </ul>
            <h3>9. Pagamento dos valores consumidos pelos Beneficiários</h3>
            <ul>
              <li>
                {' '}
                Através do NetViajes Travel Corporate Service, o Cliente e/ou Beneficiários com Perfil de Administrador
                podem cadastrar um ou mais cartões de crédito. Desta forma, o valor dos Serviços Turísticos adquiridos
                pelos Beneficiários será debitado no cartão de crédito registado por Beneficiário com Perfil de
                Administrador
              </li>
            </ul>
            <h3>10. Cobrança da taxa de serviço.</h3>
            <ul>
              <li>
                {' '}
                A Netactica Corporate poderá cobrar do Cliente uma Taxa de Serviço por cada Serviço adquirido pelos
                Beneficiários através do Serviço NetViajes Travel Corporate, de acordo com as condições de consumo
                definidas pelo Cliente e/ou Beneficiários com Perfil de Administrador. O Cliente deverá pagar a Taxa de
                Serviço junto com o Serviço adquirido, a qual será debitada no cartão de crédito cadastrado por
                Beneficiário com Perfil Administrador.
              </li>
            </ul>
            <h3>11. Conduta Penalizada pelas Companhias Aéreas.</h3>
            <ul>
              <li>
                {' '}
                O Cliente declara e concorda em saber que as condutas descritas a seguir têm sanções estritamente
                estabelecidas por cada companhia aérea em suas políticas internas, podendo variar entre si em termos de
                condições e custos. Esclarece-se que a lista de condutas penalizadas estabelecida neste parágrafo não é
                exaustiva, entendendo-se que as companhias aéreas podem ter em suas políticas outros tipos de condutas
                penalizadas que não estão contidas nas listadas abaixo.
              </li>
              <li>
                Da mesma forma, fica esclarecido que caso a Netactica Corporate seja penalizada pelas companhias aéreas
                por ações e/ou omissões do Cliente e/ou Beneficiários, a Netactica Corporate poderá cobrar o valor das
                referidas penalidades no(s) cartão(ões) de crédito do Cliente cadastrado no NetViajes Travel Corporate
                Service, com notificação prévia ao Cliente. Na referida notificação, a Netactica Corporate enviará ao
                Cliente o apoio enviado pela companhia aérea através do qual esta exige o pagamento da multa.
              </li>
            </ul>
            <h3>11.1. Churning</h3>
            <ul>
              <li>
                {' '}
                Refere-se ao processo de criar e cancelar repetidamente o mesmo segmento para o mesmo passageiro e pode
                ser apresentado das seguintes maneiras:
                <br />- O mesmo nome
                <br />- A mesma origem/destino
                <br />- A mesma data de viagem
                <br />- Número de voo igual ou diferente. Esclarece-se que a alteração do número do voo na mesma data de
                viagem só é permitida em rotas com cinco ou mais frequências diárias.
                <br />- O churning pode ocorrer na mesma ou em várias reservas
              </li>
              <li>
                O número de cancelamentos a serem considerados cancelamentos varia de acordo com a companhia aérea.
              </li>
            </ul>
            <h3>11.2. Duplicados</h3>
            <ul>
              <li>
                {' '}
                Refere-se a reservas que: i) contenham dados semelhantes; ii) estão simultaneamente ativos no sistema;
                iii) seus itinerários e datas de voo nem sempre serão idênticos e iv) são classificados em:
                <br />
                11.2.A. Reservas duplicadas: são aquelas que contêm o mesmo passageiro (nome e sobrenome), mesmas
                informações de contato principal, itinerário idêntico (a) , sobreposto (b) ou impossível de realizar (c)
                pelo mesmo passageiro.
                <br />O prazo para uma reserva ser considerada uma duplicata pode variar entre as companhias aéreas e
                isso também pode mudar dependendo se se trata de voos domésticos ou internacionais.
                <br />
                11.2.B. Segmentos duplicados: são aqueles em que um viajante possui dois segmentos ativos dentro do
                mesmo PNR, cuja origem - destino é o mesmo, com a mesma ou diferente data de voo, que possuem um número
                de voo, classe de serviço ou código diferente ou igual de status.
                <br />
                (a) Itinerário idêntico refere-se a reservas ativas simultaneamente em pelo menos um segmento ou
                origem/destino, número de voo e data exatamente iguais.
                <br />
                (b) Itinerário sobreposto refere-se a reservas ativas simultaneamente com pelo menos um segmento ou
                origem/destino, número de voo e data exatamente iguais.
                <br />
                (c) O itinerário que pode ser desfeito ocorre quando a data do último voo do primeiro PNR cai dentro de
                48 horas após o primeiro voo do segundo PNR.
              </li>
            </ul>
            <h3>11.3. Grupo oculto (hidden group)</h3>
            <ul>
              <li>
                {' '}
                Considera-se que existe um grupo oculto (hidden group)quando um grupo de 10 passageiros tem reservas que
                têm em comum as datas de saída e regresso, bem como a coincidência entre origem e destino, ponto de
                venda e agência de viagens.
              </li>
            </ul>
            <h3>11.4. No Show</h3>
            <ul>
              <li>
                {' '}
                Não comparecimento de hóspede ou passageiro com reserva confirmada e não cancelada dentro do prazo
                estipulado pelo fornecedor. Esclarece-se que é responsabilidade do Cliente notificar a Netactica
                Corporate que não é mais necessária a reserva para evitar cobranças por No Show.
              </li>
            </ul>
            <h3>11.5. Nomes fictícios</h3>
            <ul>
              <li>
                {' '}
                Nomes inseridos incorretamente, de forma incompleta ou que têm grande possibilidade de não serem
                passageiros reais. A penalidade é apresentada na medida em que as empresas aéreas exigem que os nomes e
                sobrenomes dos passageiros sejam preenchidos de forma completa e correta
              </li>
            </ul>
            <h3>11.6. Reservas de adultos com emissão de taxas CHD e INF</h3>
            <ul>
              <li>
                {' '}
                As reservas devem ter o tipo de passageiro (ADT, CHD, INF), caso contrário, por padrão é considerado
                passageiro adulto (ADT). Esclarece-se que não é permitida a entrada de passageiros com idade diferente
                da real.
              </li>
            </ul>
            <h3>11.7. Reservas fictícias e/ou especulativas</h3>
            <ul>
              <li>
                {' '}
                São aquelas que se realizam sem que o passageiro expresse a sua vontade de viajar ou face a uma procura
                crescente ou indecisão do Cliente. Esclarece-se que o sistema de reservas deve ser utilizado apenas para
                reservas reais e não para bloqueio de vagas.
              </li>
            </ul>
            <h3>11.8. Bilhete fictício</h3>
            <ul>
              <li>
                {' '}
                São os bilhetes emitidos com características diferentes do bilhete válido gerado pela companhia aérea e
                as diferenças podem residir no seguinte:
                <br />- Numeração fictícia.
                <br />- Números reais usados anteriormente em outras reservas.
                <br />- Bilhete emitido em rota diferente da reservada.
                <br />- Bilhete emitido em nome de pessoa diversa da reservada.
                <br />- Bilhete cancelado.
                <br />- Bilhete com dígito de verificação inválido.
                <br />- MCO ou qualquer outra forma de contabilidade usada como bilhete fictício.
                <br />- Números de bilhetes inseridos incorretamente.
              </li>
            </ul>
            <h3>12. Disponibilidade, segurança e estabilidade.</h3>
            <ul>
              <li>
                {' '}
                Netactica Corporate não garante a disponibilidade ou tempo de operação do Serviço NetViajes Travel
                Corporate e/ou da Plataforma. Em caso de instabilidade ou grandes inconvenientes técnicos, Netactica
                Corporate não terá qualquer responsabilidade para com o Cliente e/ou Beneficiários, mas fará todos os
                esforços para estabilizar sua operação.
              </li>
            </ul>
            <h3>13. Direitos de propriedade intelectual e industrial e independência das partes.</h3>
            <ul>
              <li>
                {' '}
                Exceto pelo que está expressamente estabelecido nestes termos e condições, nada aqui estabelecido será
                considerado como efeito de transferência, licenciamento, cessão ou cessão de quaisquer direitos de
                propriedade intelectual e/ou industrial ou outros direitos de propriedade de uma Parte à outra Parte,
                especialmente sobre os direitos que recaem sobre o Travel4Busines Service e a Plataforma, que são de
                propriedade total da Netactica Corporate, sua controladora, subsidiárias e/ou afiliadas. O Cliente e a
                Netactica Corporate são contratantes independentes e nada nestes termos e condições pretende ou cria qualquer
                tipo de empresa conjunta, sociedade, parceria, joint venture ou relação empregador/empregado entre as
                partes. Pelo exposto, as Partes cumprirão com suas obrigações perante terceiros (nas áreas trabalhista,
                previdenciária e fiscal) de forma independente
              </li>
            </ul>
            <h3>14. Confidencialidade.</h3>
            <ul>
              <li>
                {' '}
                As informações confidenciais serão quaisquer informações técnicas, comerciais, financeiras,
                estratégicas, jurídicas e/ou de qualquer natureza relacionadas com as operações comerciais presentes e
                futuras das Partes envolvidas nestes termos e condições, que sejam divulgadas e/ou entregues por escrito
                entre estes, indicando expressamente que a referida informação é confidencial ou que uma pessoa no
                momento da divulgação pode presumir, nas circunstâncias específicas em que a divulgação foi feita, que a
                referida informação é confidencial. O dever de sigilo estabelecido nesta condição terá duração para as
                Partes durante a vigência destes termos e condições e até 3 (três) anos após o seu término.
              </li>
            </ul>
            <h3>15. Gerenciamento de bancos de dados.</h3>
            <ul>
              <li>
                {' '}
                Base de dados deve ser entendida como o conjunto organizado de dados pessoais que podem ser objeto de
                qualquer operação ou conjunto de operações: coleta, armazenamento, uso, circulação ou exclusão nos
                termos da Lei Federal de Proteção de Dados Pessoais na Posse do Indivíduos, seus regulamentos e vários
                regulamentos atuais e relacionados. Tanto a Netactica Corporate como o Cliente devem garantir o correto
                manuseio, uso e disposição das informações contidas nas bases de dados do Cliente ou da Netactica
                Corporate, nas quais cada um deve ter a devida autorização dos titulares dos dados pessoais contidos.
                neles para o seu tratamento, e cumprirão as disposições do referido regulamento.
                <br />
                Esclarece-se que o Cliente e os Beneficiários devem aceitar o Aviso de Privacidade da Netactica
                Corporate no momento do registo no NetViajes Travel Corporate Service e/ou antes de confirmar a compra
                de um Serviço de viagens.
              </li>
            </ul>
            <h3>16. Indenização. </h3>
            <ul>
              <li>
                {' '}
                Netactica Corporate e o Cliente concordam em permanecer inofensivos em relação a terceiros que possam
                ser afetados. Tendo em vista a obrigação de não sofrer danos, serão responsáveis pelos danos que suas
                próprias ações ou omissões possam causar a terceiros
              </li>
            </ul>
            <h3>17. Acordo Integral. </h3>
            <ul>
              <li>
                {' '}
                Estes termos e condições constituem o acordo integral entre Netactica Corporate e o Cliente em relação
                ao uso do Serviço NetViajes Travel Corporate e, consequentemente, substituem qualquer outro acordo
                verbal ou escrito anterior sobre o mesmo objeto.
              </li>
            </ul>
            <h3>18. Impostos.</h3>
            <ul>
              <li>
                {' '}
                Cada Parte será responsável pelo pagamento dos tributos que a Legislação Aplicável lhes incidir por
                ocasião das obrigações previstas nestes termos e condições.
              </li>
            </ul>
            <h3>19. Declaração de origem dos fundos</h3>
            <ul>
              <li>
                {' '}
                O Cliente declara que seus rendimentos provêm de atividades jurídicas, não incluídas nas listas de
                controle de lavagem de dinheiro e financiamento do terrorismo, administradas por qualquer autoridade
                nacional ou estrangeira, e que conseqüentemente são obrigados a responder por todos os danos que foi
                causado como consequência desta declaração. De acordo com o anterior, a Netactica Corporate poderá
                privar o Cliente do uso do Serviço NetViajes Travel Corporate e/ou da Plataforma se o Cliente constar da
                lista do Escritório de Controle de Ativos no Exterior - OFAC emitida pela Tesouraria. dos Estados Unidos
                da América, a lista da Organização das Nações Unidas, a lista de Terroristas dos Estados Unidos da
                América, a lista da União Europeia de Pessoas Catalogadas como Terroristas e a Lista da União Europeia
                de Organizações Terroristas e outras listas públicas relacionadas com a questão da lavagem de dinheiro e
                financiamento do terrorismo
              </li>
            </ul>
            <h3>21. Ética empresarial e anticorrupção</h3>
            <ul>
              <li>
                {' '}
                O Cliente compromete-se a implementar mecanismos de controlo interno de forma a prevenir a ocorrência de
                actos de corrupção nas negociações realizadas. De acordo com o exposto, compromete-se a não receber ou
                oferecer, direta ou indiretamente, de e para os funcionários, administradores ou subordinados da Rappi
                Travel, sua empresa controladora, subsidiárias ou afiliadas: (i) somas de dinheiro, (ii) qualquer objeto
                de valor pecuniário ou (iii) outro benefício ou utilidade, em troca de: (i) praticar, (ii) omitir, (iii)
                ou atrasar, qualquer ato relacionado ao exercício de suas funções
                <br />O Cliente declara e garante que tanto o Cliente quanto seus executivos, funcionários, diretores ou
                subcontratados cumprem os regulamentos anticorrupção, incluindo, mas não se limitando aos contidos na
                Lei Geral de Responsabilidades Administrativas, a Lei sobre Práticas Corruptas no Exterior dos Estados
                Unidos da América. De 1977, a Lei de Suborno do Reino Unido de 2010 ou aqueles que a modificam,
                sub-rogam, regulam ou desenvolvem, bem como as regulamentações nacionais e internacionais relacionadas à
                prevenção de fraude, suborno, corrupção, lavagem de dinheiro dinheiro e terrorismo. Da mesma forma, o
                Cliente declara e garante que nem ele nem seus funcionários, funcionários, diretores ou subcontratados
                são objeto de investigações, acusações ou processos relacionados à violação das normas anticorrupção e
                que não foi sujeito a sanções criminais, disciplinares ou contratuais derivadas de violação de tal
                regulamento. O Cliente compromete-se a cumprir as leis anticorrupção e declara que qualquer violação
                constitui uma violação destes termos e condições. Da mesma forma, o Cliente compromete-se a notificar a
                Netactica Corporate de qualquer notificação associada a uma investigação, procedimento, sanção ou
                similar, iniciada contra ele ou contra qualquer um de seus oficiais, funcionários, gerentes ou
                subcontratados, no prazo de 24 (vinte e quatro) horas após a data em que teve conhecimento da
                notificação da investigação.
              </li>
            </ul>
            <h3>22. Política de gerenciamento</h3>
            <ul>
              <li>
                {' '}
                Ao aceitar estes termos e condições, o Cliente concorda em conhecer e cumprir a Política de Gestão para
                a Prevenção e Controle do Risco de Lavagem de Dinheiro e Financiamento ao Terrorismo da Netactica
                Corporate
              </li>
            </ul>
            <h3>23. Jurisdição</h3>
            <ul>
              <li>
                {' '}
                Qualquer controvérsia ou diferença gerada por ocasião dos presentes termos e condições ou de sua
                execução, será tentada em primeira instância por solução direta entre as Partes. Se 30 (trinta) dias
                corridos após o surgimento da controvérsia, esta não tiver sido resolvida, as Partes se submeterão aos
                tribunais da jurisdição ordinária da São Paulo/SP
              </li>
            </ul>
            <h3>24. Vigência.</h3>
            <ul>
              <li>
                {' '}
                Este Termos e Condições é válido por tempo indeterminado, durante todo o tempo de uso da plataforma
                NetViajes Travel Corporate.
              </li>
            </ul>
          </div>
        </div>
      </>
    )}

    {country !== 'BR' && (
      <>
        <div>
          <div>
            <p>
              En seguida expondremos los términos y condiciones que usted Usuario debe tener en cuenta antes de hacer
              uso del sitio web, le agradecemos leerlo cuidadosamente antes de aceptarlos ya que éste constituye y
              ratifica su consentimiento de aceptación. En caso de tener alguna duda o inquietud al respecto permítanos
              conocerla a través de nuestros canales de atención.
            </p>
            <h4>Condiciones generales</h4>
            <h3>1. Estructura y responsabilidades</h3>
            <ul>
              <li>
                {' '}
                Netviajes es una unidad de negocios de Netactica Colombia SAS, sociedad legalmente constituida bajo las
                leyes colombianas, y que en adelante se denominará “Netviajes” o la “Agencia de Viajes” o la “Agencia”.
                La Agencia actúa como intermediario entre los usuarios o viajeros y las entidades o personas encargadas
                de proporcionar los servicios de transporte aéreo o terrestre, alojamiento, alimentación, o cualquier
                otro servicio y que en adelante se denominarán “el Proveedor/ los Proveedores” contratado(s) a través
                del sitio de Internet de esta Agencia de Viajes (el “Sitio web”).
              </li>
              <li>
                {' '}
                Hemos dispuesto una plataforma que funciona con diferentes aplicaciones que ofrecen seguridad
                informática. Sin embargo, recuerde que en su calidad de usuario web es recomendable que se informe
                acerca de las buenas prácticas que debe tener en cuenta al utilizar medios electrónicos para minimizar
                el riesgo de ser víctima de virus u otros componentes peligrosos que puedan afectarle y por los cuales
                la agencia no podrá asumir responsabilidad.
              </li>
              <li>
                {' '}
                La Agencia se compromete a cumplir con los servicios de intermediación mencionados, con las salvedades
                especificadas en estas “Condiciones Generales” sin responsabilizarse directamente por el incumplimiento
                de dichas entidades en la ejecución de sus obligaciones, ni por imprevistos ocasionados por huelgas,
                condiciones climáticas, atrasos, terremotos, cuarentenas, así como por los perjuicios materiales,
                personales o morales que pueda sufrir el pasajero por pérdida, daño o hurto de equipaje, ni por
                accidentes, enfermedades o fallecimientos. En cualquiera de éstos eventos el usuario podrá reclamar
                directamente ante las empresas prestadoras del servicio incumplido, o solicitar la intermediación de la
                Agencia de Viajes, en cuyo caso a solicitud expresa de la Agencia, el usuario otorgará la subrogación de
                derechos a fin de surtir el trámite de reclamación ante la empresa operadora o prestadora del servicio.
                Estas “Condiciones Generales” son regidas por las normas aplicables en Colombia.
              </li>
              <li>
                {' '}
                Las políticas de reembolso de los servicios no prestados en razón a situaciones de fuerza mayor o caso
                fortuito, acción u omisión de terceros o del pasajero, no atribuibles a la Agencia de Viajes, antes o
                durante el viaje, que puedan ser objeto de devolución, serán definidas por cada operador La Agencia no
                es responsable solidario por las sumas solicitadas en reembolso. El porcentaje de reembolso dependerá de
                las condiciones propias del servicio contratado y del Proveedor.
              </li>
              <li>
                La Agencia de Viajes no asume responsabilidad frente al usuario o viajero por eventos tales como
                accidentes, huelgas, asonadas, terremotos, fenómenos climáticos o naturales, condiciones de seguridad,
                factores políticos, negación de permisos de ingreso o visados,asuntos legales del viajero, asuntos de
                salubridad y cualquier otro caso de fuerza mayor o caso fortuito que pudiere ocurrir antes o durante el
                viaje. <br /> En caso de fuerza mayor o caso fortuito antes o durante el viaje (accidentes, huelgas,
                asonadas, terremotos, factores climáticos, condiciones de seguridad, factores políticos, negación de
                permisos de ingreso, asuntos de salubridad, entre otros), o simplemente con el fin de garantizar el
                éxito del plan, el operador y/o la agencia podrán modificar, reemplazar o cancelar itinerarios, fechas,
                vuelos, hoteles, servicios opcionales, lo cual es desde ahora aceptado por el pasajero al momento de
                adquirir los servicios
              </li>
              <li>
                {' '}
                Le recomendamos informarse acerca de la necesidad de visado para la realización de su viaje. En todo
                caso será de la exclusiva responsabilidad del pasajero, el trámite y cumplimiento de los requisitos
                informados.&nbsp;En caso de negativa de visa, el reembolso de las sumas pagadas por el&nbsp;solicitante
                quedara sujeto a la autorización del proveedor u operador del servicio.&nbsp; En las condiciones
                específicas de cada plan se informará la forma de pago y plazo.
              </li>
              <li>
                {' '}
                La Agencia,&nbsp;podrá orientar al pasajero en los eventos de extravío de su equipaje o documentos de
                viaje, sin embargo en ninguna circunstancia, responderá&nbsp;por el extravío, daño, deterioro o pérdida
                de dichos elementos, siendo de exclusiva responsabilidad del pasajero.
              </li>
              <li>
                {' '}
                El Usuario podrá solicitar a La Agencia información acerca de las restricciones que establecen las
                aerolíneas en cuanto a elementos no permitidos, peso máximo y número de piezas por pasajero, personas
                permitidas en los atractivos o sitios turísticos, limitaciones o impedimentos de acceso por cupo máximo.
                No obstante, será de exclusiva responsabilidad del pasajero el cumplimiento de dichas políticas, las
                cuales podrán variar por disposición de las empresas de transporte o del prestador de los
                servicios.&nbsp;
              </li>
              <li>
                {' '}
                Toda la información adicional relativa a vigencias, condiciones, impuestos de salida de Colombia y en el
                exterior, tasas, cargos y demás pagos obligatorios, medidas de salud preventivas del destino, servicios
                de asistencia podrán ser consultados, en caso de cualquier inquietud al respecto el Usuario podrá
                comunicarse con nuestra línea se atención al cliente.
              </li>
              <li>
                {' '}
                Todos los precios, tarifas, impuestos, tasas o contribuciones, presentados.&nbsp;Están sujetos a
                disponibilidad y vigencia. Aplican restricciones y condiciones para cada tarifa publicada según su
                vigencia.
              </li>
              <li>
                {' '}
                Las tarifas hoteleras pueden variar dependiendo de la acomodación seleccionada. Las políticas de
                cancelación, penalidades, restricciones&nbsp;y condiciones&nbsp;particulares de los servicios ofrecidos
                por la Agencia podrán ser consultadas por el usuario en el momento de solicitar el servicio.
              </li>
              <li>
                {' '}
                La Agencia establece su límite de responsabilidad, por lo cual: (i) se reserva expresamente el derecho
                de corregir cualquier error de información en contenido, descripción o precio en el Sitio Web, reservas
                formuladas en virtud de un precio incorrecto. En tal caso, si está disponible, le ofrecerá la
                oportunidad de mantener su&nbsp;reserva en el precio correcto o la cancelación de la reserva, sin
                penalización, siempre y cuando cumpla, con las anteriores características; (ii) El Sitio web se
                encuentra diseñado para la oferta de servicios turísticos o complementarios con la implementación de
                contenidos, clausulas, términos y condiciones dispuestos para su aceptación sin posibilidad de convenir,
                subcontratar o delegar sus derechos, deberes y obligaciones aquí enunciadas.
              </li>
            </ul>
            <p>
              {' '}
              El&nbsp;Usuario declara que conoce y acepta en su integridad estas condiciones,&nbsp;las cuales
              constituyen el acuerdo único, total y excluyente de cualquier pacto o disposición legal en contrario,
              acerca de los términos, condiciones y restricciones de los servicios contratados.{' '}
            </p>
            <h3>2. Condiciones de uso personal y comercial</h3>
            <ul>
              <li>
                <b>Adhesión.</b> El Sitio se encuentra diseñado para la oferta de servicios turísticos con la
                implementación de contenidos, clausulas, términos y condiciones dispuestos para su aceptación sin
                posibilidad de convenir, subcontratar o delegar sus derechos, deberes y obligaciones aquí enunciadas.
              </li>
              <li>
                <b>Herramientas de acceso. </b> Para acceder al Sitio web, el Usuario debe contar con un el equipo y los
                sistemas informáticos necesarios para realizar la conexión a la red de internet, incluyendo un terminal
                que sea adecuado (ordenador, teléfono, etc.) y un módem u otro dispositivo de acceso a la red internet.{' '}
                <br /> El servicio de conexión de internet, tarifas de acceso y costos adicionales por este concepto
                deberán ser asumidos de manera exclusiva por el Usuario, y en ningún evento serán responsabilidad de la
                Agencia.
              </li>
              <li>
                <b>Responsabilidad / veracidad.</b> Al contratar Servicios Turísticos a través del Sitio web de la
                Agencia, el Usuario garantiza que: (i) es mayor de edad; (ii) posee plena capacidad para celebrar
                contratos; (iii) acepta expresamente la recepción de estos Términos y Condiciones como medio alternativo
                de comunicación al soporte físico; (iv) solo utiliza la el Sitio web de la Agencia para reservar o
                contratar Servicios Turísticos para el propio Usuario y/o para otra persona para quien el Usuario tenga
                autorización de actuar; (v) toda la información que brinda a la Agencia es verídica, exacta, actual y
                completa; (vi) acepta que es consciente de todas las responsabilidades que deriven del uso del Sitio web
                ya sean estas provocadas por el Usuario o por terceros operando bajo su contraseña; y (vii) Como
                condición para el uso de este Sitio web, garantiza que no realizará en el mismo ninguna actividad ilegal
                o prohibida en los términos, condiciones y requerimientos arriba mencionados.
              </li>
              <li>
                <b> Información.</b> La página web le solicitará al Usuario diligenciar sus datos personales y el correo
                electrónico a donde le será enviada la información de confirmación de pago y el comprobante para la
                utilización del servicio. Por lo cual, es de exclusiva responsabilidad del Usuario diligenciar
                correctamente la información del correo electrónico de contacto.
              </li>
              <li>
                <b>Pago con tarjeta de crédito. </b> Si el Usuario realiza un pago con tarjeta de Crédito deberá tener
                en cuenta: (i) las condiciones previamente fijadas con el Banco emisor de la tarjeta de crédito, estas
                condiciones pueden afectar el costo financiero total. Por lo cual, le recomendamos informarse con la
                entidad bancaria acerca de las condiciones de uso y las tasas, impuestos o intereses aplicables al medio
                de pago antes de aplicar la modalidad de pago en cuotas.(ii) El Sitio web recibe como forma de pago
                tarjetas locales de crédito, débito (aplican restricciones) de las franquicias Master Card y Visa. (iii)
                Recuerde que los datos suministrados del tarjetahabiente deben ser los mismos que reposan en la entidad
                financiera (nombres y apellidos como aparecen en el plástico, cédula, dirección de correspondencia,
                teléfono).
              </li>
              <li>
                <b>Cargos al medio de pago.</b>
                Cuando el Usuario reserva uno o más Servicios Turísticos a través de la Agencia, debe abonar (i) el
                precio o tarifa fijada por el Proveedor, (ii) los impuestos, tasas y/o percepciones fiscales aplicables
                al Servicio Turístico y, en caso de corresponder, (iii) el cargo de gestión por el servicio de
                intermediación de la Agencia (el “Cargo de Gestión”). Es importante mencionar que la Agencia actúa en
                nombre y representación del Proveedor de los Servicios y que los valores correspondientes al precio o
                tarifa de los Servicios Turísticos son trasladados (endosados) al Proveedor. La Agencia podrá a su
                discreción ofrecer distintas modalidades para poder efectuar y abonar sus reservas de Servicios
                Turísticos dependiendo del Servicio a ser adquirido, el Proveedor que lo/s proporcione y el medio
                utilizado para el pago. Los medios y formas de pago disponibles para cada Servicio Turístico son los
                informados en el Sitio web en forma previa a ingresar la solicitud de compra.
              </li>
              <li>
                <p> Modificaciones, cambios o cancelaciones. </p> Después de confirmar la compra, el Usuario deberá
                tener en cuenta las siguientes condiciones antes de solicitar cambios, modificaciones o cancelaciones:
                (i) El Usuario deberá cumplir con los requisitos obligatorios para el trámite según el tipo de servicio
                adquirido y siempre que la tarifa seleccionada por el Usuario así lo permita, la Agencia realizará las
                gestiones de presentación y seguimiento de su solicitud, pero la decisión final será del Proveedor del
                Servicio Turístico. (ii) &nbsp;La forma de proceder y las condiciones especiales que rigen para casos de
                cambios o cancelaciones en una reserva confirmada por el Usuario, son determinadas por los Proveedores
                de los Servicios Turísticos, quienes podrán establecer multas o penalidades aplicables para los cambios
                solicitados. Estas condiciones están disponibles para su consulta en nuestro Sitio web, revíselas antes
                de reservar y recuerde que hay Servicios Turísticos que, por disposición de los Proveedores, no admiten
                cambios y/o devoluciones, o los admiten con restricciones y/o con penalidades, - aún en casos de
                enfermedad, huelga, fenómenos climáticos, entre otros.-. Tenga en cuenta que cada Proveedor define sus
                penalidades sin intervención o injerencia de la Agencia. (iii) Cuando el Usuario solicita un cambio,
                está cancelando una reserva confirmada y solicitando otra nueva que se regirá por las condiciones
                particulares aplicables al momento en el que el Usuario realiza el cambio, por tal razón, el Usuario
                deberá asumir además de los costos de las penalidades aplicables, podría existir una diferencia (valor
                resultante de la diferencia entre la tarifa originalmente comprada y la nueva tarifa según
                disponibilidad tarifaria al momento de efectuar el cambio). El Usuario debe tener en cuenta que las
                tarifas turísticas son dinámicas y dependen de variables como anticipación de compra, fechas de viaje,
                promociones estacionales y, en el caso de vuelos, también de las restricciones tarifarias, los cambios
                deberán realizarse en las mismas clases emitidas o bien en clases superiores. Aclaramos que no es
                posible realizar cambios por tarifas más económicas publicadas posteriormente a la emisión del tiquete
                aéreo adquirido. (iv) las devoluciones aprobadas por el Proveedor podrán ser efectuadas mediante un
                crédito o una reversión de cargo a la misma tarjeta con la cual se hizo la reserva, previa autorización
                del titular de la tarjeta de crédito. Para pagos en efectivo, la Agencia le solicitara al Usuario sus
                datos bancarios para realizar el reembolso mediante transferencia bancaria. Los plazos de reembolso y/o
                de la reversión de cargo dependerán de cada Proveedor (las compañías aéreas se estiman de entre 30 y 120
                días). (v) los Proveedores de servicios no están obligados a obviar las condiciones del contrato aún en
                casos acreditados de enfermedad o incapacidad física que les impida viajar; es decir que si la tarifa
                abonada prevé el cobro de penalidad para realizar modificaciones/devoluciones o no permite cambios y/o
                reintegro, el Proveedor puede cobrar esos cargos o negar la devolución del costo de la reserva. (vi) El
                cargo de gestión cobrado por la Agencia es de carácter no reembolsable. En caso de cancelación de
                reservas confirmadas por cualquier motivo, dicho cargo de gestión no será reintegrado ya que corresponde
                a un servicio efectivamente prestado por la Agencia. Asimismo, en el supuesto de que el Usuario solicite
                el cambio o cancelación de un Servicio Turístico, la Agencia podrá cobrar un cargo de gestión adicional.
                (vii) realizar una cancelación con posterioridad a la compra, siempre que las condiciones particulares
                del Servicio Turístico lo permitan, tenga en cuenta que la Agencia no reintegrará ni se hará responsable
                de los intereses que la transacción original haya generado, toda vez que la Agencia no percibe dichos
                intereses.{' '}
              </li>
              <li>
                {' '}
                Retracto. Los usuarios podrán ejercer el derecho de retracto frente a las compras realizadas en el Sitio
                web de acuerdo a lo establecido en el artículo 47 de la ley 1480 de 2011, el término máximo para ejercer
                el derecho de retracto será de cinco (5) días hábiles contados a partir del día en que se realizó la
                compra, siempre y cuando no haya comenzado a prestarse el servicio antes de cinco (5) días. Para ejercer
                el derecho de retracto, el Usuario deberá informar su decisión a través de nuestra línea de atención al
                cliente en horarios de oficina de Lunes a viernes de 8 am a 5pm y/o en la página web ingresando todos
                los datos en el formato de Modificaciones, cambios y cancelaciones ubicado en un link en la parte
                inferior de este Sitio web.
                <br /> En caso de que se ejerza el derecho de retracto conforme a lo establecido en estos términos y
                condiciones, La Agencia realizará el trámite ante el Proveedor (es) y en caso de haber sido abonado,
                será el Proveedor del servicios quien realizará directamente el abono al Usuario, mediante un crédito o
                reversión de cargo al medio de pago utilizado para la compra, lo que resulte más conveniente. En
                eventuales casos de pago por transferencia, la Agencia podrá solicitar datos o soportes para gestionar
                el reembolso de dinero por ese medio.
              </li>
              <li>
                <b> Aplicación desistimiento para tiquetes aéreos.</b> El Pasajero podrá desistir del viaje dando aviso
                a la aerolínea o a la agencia de viajes con un plazo de al menos 24 horas antes del inicio de vuelo.
                Este derecho sólo puede ser ejercido por el pasajero. La Compañía aplicará una retención de acuerdo a la
                regla tarifaria aplicable sin que ésta exceda el 10% del valor de la tarifa base incluyendo el Q de
                Combustible. El desistimiento no aplica para las tarifas promocionales. El reembolso se hará efectivo
                dentro de los treinta (30) días siguientes a la fecha de notificación, en la misma forma en que se
                realizó el pago.
              </li>
              <li>
                <b> Reversiones de pago. </b> El Decreto 587 de 2016 del Ministerio de Comercio, Industria y Turismo
                Colombiano le otorga al Usuario la facultad de solicitar la reversión de su pago, aplica cuando la
                adquisición de productos se realice a través del Sitio web, siempre que el pago se haya realizado con
                una tarjeta de crédito, débito o cualquier otro instrumento de pago, electrónico (Recuerde que si la
                compra corresponde a un&nbsp;tiquete aéreo, no podrá acogerse a ésta figura por expresa disposición de
                la regulación mencionada). En estos casos, el consumidor podrá solicitar reversión de pagos por
                cualquiera de las siguientes causales:
                <ul>
                  <li>Cuando fue objeto de fraude.</li>
                  <li>El cargo generado sobre el medio de pago corresponde a una operación no solicitada.</li>
                  <li>El producto/servicio adquirido no fue recibido.</li>
                  <li>
                    El producto/servicio recibido no corresponde a lo solicitado. (no cumple con las
                    característicasinformadas o atribuidas a éste){' '}
                  </li>
                  <li>El producto/servicio se encuentra defectuoso.</li>
                </ul>{' '}
                El consumidor podrá solicitar la reversión parcial del pago de aquellos respecto de los cuales se
                presente alguno de los eventos mencionados anteriormente, expresando claramente cuál es el valor por el
                cual se solicita la reversión, el cual deberá corresponder al valor del producto o productos respecto de
                los cuales se presenta la causal.
                <br /> Para que proceda la reversión del pago, dentro los cinco (5) días hábiles siguientes a la fecha
                en que el usuario tuvo noticia de la operación fraudulenta o no solicitada o que recibió la confirmación
                de una compra no solicitada, el consumidor deberá presentar queja ingresando todos los datos en el
                formato de Modificaciones, cambios y cancelaciones ubicado en un link en la parte inferior del Sitio Web
                y notificar de la reclamación al emisor del instrumento de pago electrónico utilizado para realizar la
                compra, el cual, en conjunto con los demás participantes del proceso de pago, procederán a reversar la
                transacción al comprador en el término de quince (15) días hábiles.
                <br /> La Agencia advierte al Usuario que en virtud de lo dispuesto por el artículo 2.2.2.51.10 del
                Decreto 587 de 2016, si como consecuencia de su solicitud de reversión, el Usuario recibiera montos que
                exceden lo originalmente pagado, el Usuario será responsable de la devolución de los mismos. Es
                importante aclarar que de acuerdo a lo establecido en el artículo 2.2.2.51.12. del Decreto 587 de 2016,
                si se demuestra que el Usuario no se encontraba incurso en ninguna de las causales de reversión
                establecidas en el formulario, la Agencia y/o el emisor de su instrumento de pagos podrán cargar
                definitivamente la transacción reclamada a su tarjeta o medio de pago.
                <br /> Como lo establece la regulación, la Agencia deja constancia que de demostrarse la Mala Fe del
                consumidor en el proceso de reversión será sancionado por la Superintendencia de Industria y Comercio,
                en los términos artículo 2.2.2.51.13, del Decreto 587 de 2016 hasta con cincuenta (50) salarios mínimos
                mensuales legales vigentes (SMMLV).
              </li>
              <li>
                <b>Documentación:&nbsp;</b>
                El Usuario declara que el viajero conoce y que cumplirá con los requisitos gubernamentales de
                documentación de salida, entrada y otros. En caso de inquietudes al respecto podrá contactarse con
                nuestra línea de atención al cliente.
              </li>
              <li>
                <b>Reclamaciones:</b>
                &nbsp;Deberán ser hechas por medio del Sitio web a través del link Modificaciones, solicitudes y cambios
                diligenciando la información solicitada en el formulario. Se recomienda realizar una descripción
                detallada de los hechos adjuntando de inmediato la copia de los antecedentes de respaldo, explicando lo
                ocurrido y formulando en términos claros y simples la solución que desea. Con base en la información
                suministrada la Agencia analizará el reclamo, y dará respuesta al mismo correo electrónico informado por
                el Usuario.
              </li>
              <li>
                <b>Confirmación de reserva. </b>
                Una vez terminado el proceso el Usuario recibirá dos correos electrónicos: uno de confirmación
                automática de la plataforma de pago y otro de la confirmación de su voucher para la prestación del
                servicio, dicha información será enviada al correo electrónico registrado en la reserva.
              </li>
              <li>
                <b>Antes de contratar</b>, el Usuario se obliga a revisar las condiciones particulares de cada Servicio
                Turístico y de cada Proveedor. La Agencia no se hace responsable ni tiene injerencia en las condiciones
                particulares establecidas por cada Proveedor para la prestación de sus Servicios Turísticos.
              </li>
            </ul>
            <p>
              Estas condiciones son las de carácter general que se aplican a los servicios de intermediación que le
              presta La Agencia y bajo ningún aspecto reemplazan o modifican las limitaciones de responsabilidad
              legalmente establecidas, ni a las condiciones especiales que cada Proveedor Turístico ha definido para sus
              Servicios Turísticos.
            </p>
            <h3>3. Términos y condiciones específicos aplicable por tipo de servicio</h3>
            <h3>3. 1 Aéreo</h3>
            <ul>
              <li>
                {' '}
                Tarifas económicas, promocionales y turista con restricciones. En el momento en que el Usuario solicita
                cotizar un tiquete aéreo, el Sitio Web mostrará disponibilidad de las tarifas más económica encontradas
                en el GDS (Sistema de distribución de aerolíneas) en el momento de la consulta, con restricciones para
                el cambio o reembolso del boleto y que en caso de solicitarlo podrán generan un sobrecargo que deberá
                ser asumido por el Usuario. Con lo cual, es importante que el Usuario se asegure de verificar el detalle
                de las restricciones de la tarifa antes de cerrar la transacción de compra. Es importante mencionar que,
                la Agencia no se encuentra autorizada a variar ni modificar en ningún caso las regulaciones de los
                tiquetes aéreos.&nbsp;
              </li>
              <li>
                {' '}
                Tasas administrativas. Las tasas administrativas que se facturan por pasajero no son reembolsables por
                regulación.
              </li>
              <li>
                {' '}
                Disponibilidad de producto. Las compras de tiquetes aéreos con pago electrónico deben realizarse con por
                lo menos&nbsp;48 horas de antelación a la fecha de salida del viaje y dentro del itinerario solicitado
                uno de los trayectos debe originar en Colombia.
              </li>
              <li>
                {' '}
                Disponibilidad de producto. Las compras de tiquetes aéreos con pago electrónico deben realizarse con por
                lo menos&nbsp;48 horas de antelación a la fecha de salida del viaje y dentro del itinerario solicitado
                uno de los trayectos debe originar en Colombia.
              </li>
              <li>
                {' '}
                Funcionalidad. El Sitio web está habilitado para generar reservas de tiquetes aéreos para adultos y
                niños, sin embargo restringe la compra de tiquete para infantes o niños que viajen solos, por lo cual si
                requiere un servicio especial para menores que viajen sin acompañante mayor de 18 años, deberá ser
                solicitado por canales de atención al cliente. Es importante que los adultos y los niños que viajen
                juntos se encuentren dentro de la misma reserva.
              </li>
              <li>
                {' '}
                Tarifas promocionales y aerolíneas de bajo costo. Recuerde que las tarifas promocionales no son
                reembolsables. Tenga presente que cuando reserva un vuelo de una aerolínea identificada como bajo
                costo,&nbsp;la tarifa publicada no permite cambios ni cancelaciones, no incluye reserva de asiento, ni
                equipaje facturado (solo equipaje de mano), ni servicios complementarios tales como refrigerios y/o
                comidas y/o entretenimiento a bordo. Todos estos servicios se consideran adicionales y se ofrecen bajo
                diferentes condiciones según cada aerolínea y a un costo diferencial. Tenga en cuenta que las compañías
                low-cost suelen operar en aeropuertos pequeños, regionales y/o secundarios. Antes de confirmar su
                solicitud de compra, revise atentamente las condiciones y tarifas que son informadas para cada caso ya
                que algunos de los servicios adicionales deben ser reservados y abonados con anticipación. Sin embargo
                algunos otros pueden ser adquiridos durante el vuelo, esto queda a discreción exclusiva de la aerolínea.
              </li>
              <li>
                {' '}
                Condiciones de compra. Verifique en las condiciones de compra del tiquete que está adquiriendo, es
                importante conocerlas en caso de que usted decida desistir del viaje después de haber realizado la
                compra.
              </li>
              <li>
                {' '}
                Reprogramaciones- Demoras y cancelaciones de vuelos. En ocasiones las aerolíneas podrían modificar
                ciertos itinerarios como fechas, horas de vuelo, podrán reprogramarlos y/o cancelarlos. El transportador
                está habilitado a realizar modificaciones en los vuelos programados, en tanto las comunique a esta
                autoridad aerocomercial conforme la regulación vigente y en estos casos la Agencia no tiene ninguna
                injerencia ni intervención en relación con las modificaciones que podrían sufrir los vuelos. De
                producirse alguna de las modificaciones mencionadas con antelación de 24 horas a la hora de salida del
                vuelo, por instrucciones del prestador del servicio, la Agencia informará las alternativas disponibles y
                sólo procederá a confirmar las modificaciones con su expresa confirmación o aceptación previa. Cualquier
                reclamo o solicitud relacionada con la prestación del servicio escogido deberá ser dirigida a la
                aerolínea, siendo éstas las que prestan el servicio de transporte. Se deja constancia de con una
                antelación inferior a 24 horas de la salida del vuelo la agencia no puede realizar ninguna gestión sobre
                el tiquete aéreo.
              </li>
              <li>
                {' '}
                Solicitud de cancelación –cambios de itinerario. En caso de solicitar modificaciones o cambios sobre los
                tiquetes emitidos se aplican restricciones y cargos adicionales establecidos por las Aerolíneas. En caso
                en que de acuerdo con la reglamentación dispuesta por la Compañía Aérea- la tarifa seleccionada por el
                Usuario sí permitiera cancelaciones, la Agencia realizará las gestiones de presentación y seguimiento de
                su solicitud de cancelación frente a la aerolínea, y será ésta quien deberá proceder a la devolución,
                mediante un crédito o una reversión de cargo a su tarjeta de crédito. Si el pago hubiera sido efectuado
                mediante un medio de pago diferente, la Agencia tramitará la devolución al medio de pago original.
                Además, tanto en el caso de cambios como de cancelaciones, la Agencia podrá cobrar un cargo de gestión
                adicional.
              </li>
              <li>
                {' '}
                Tramite de Rembolso. El trámite del reembolso de un tiquete lo realiza la aerolínea y el tiempo estimado
                de reintegro depende de esta, siempre y cuando el tiquete aéreo sea reembolsable. En caso de reembolso,
                se aplicarán las normas y penalidades establecidas por cada aerolínea con base en el tipo de tarifa y
                sus restricciones.
              </li>
              <li>
                {' '}
                Retracto. Los usuarios podrán ejercer el derecho de retracto frente a las compras realizadas en el Sitio
                web de acuerdo a lo establecido en el artículo 47 de la ley 1480 de 2011, el término máximo para ejercer
                el derecho de retracto será de cinco (5) días hábiles contados a partir del día en que se realizó la
                compra, siempre y cuando no haya comenzado a prestarse el servicio antes de cinco (5) días. Para ejercer
                el derecho de retracto, el Usuario deberá informar su decisión a través de nuestra línea de atención al
                cliente en horarios de oficina de Lunes a viernes de 8 am a 5pm y/o en la página web ingresando todos
                los datos en el formato de Modificaciones, cambios y cancelaciones ubicado en un link en la parte
                inferior de este Sitio web.
                <br /> En caso de que se ejerza el derecho de retracto conforme a lo establecido en estos términos y
                condiciones, La Agencia realizará el trámite ante el Proveedor (es) y en caso de haber sido abonado,
                será el Proveedor del servicios quien realizará directamente el abono al Usuario, mediante un crédito o
                reversión de cargo al medio de pago utilizado para la compra, lo que resulte más conveniente. En
                eventuales casos de pago por transferencia, la Agencia podrá solicitar datos o soportes para gestionar
                el reembolso de dinero por ese medio.
              </li>
              <li>
                {' '}
                Aplicación desistimiento para tiquetes aéreos. El Pasajero podrá desistir del viaje dando aviso a la
                aerolínea o a la agencia de viajes con un plazo de al menos 24 horas antes del inicio de vuelo. Este
                derecho sólo puede ser ejercido por el pasajero. La Compañía aplicará una retención de acuerdo a la
                regla tarifaria aplicable sin que ésta exceda el 10% del valor de la tarifa base incluyendo el Q de
                Combustible. El desistimiento no aplica para las tarifas promocionales. El reembolso se hará efectivo
                dentro de los treinta (30) días siguientes a la fecha de notificación, en la misma forma en que se
                realizó el pago.
              </li>
              <li>
                {' '}
                Información y titularidad del tiquete aéreo. &nbsp;El tiquete aéreo es emitido a nombre del pasajero es
                nominativo, personal e intransferible. Por lo cual, es importante que el Usuario preste atención al
                ingresar su(s) nombre(s) y apellido(s) en el(los) lugar(es) indicado(s) para ello y en un todo conforme
                con su la documentación de viaje del pasajero. El Usuario tiene disponible una casilla para nombre(s) y
                otro para apellido(s), en todo caso el Usuario tiene posibilidad de revisar esta información previo a
                confirmar la solicitud de compra. Los tiquetes aéreos, se emitirá/n automáticamente con la información
                ingresada por el Usuario en la Plataforma sin intervención manual alguna de parte de la Agencia. Una vez
                emitido(s) el(los) tiquete(s) aéreo(s) y generado el registro de tiquete electrónico, las aerolíneas no
                admiten (o en ciertos casos los admiten con costos) cambios de nombres o apellidos en un tiquete aéreo,
                ni aún en casos de errores de digitación en los nombres de los pasajeros y/o de nombres y apellidos
                invertidos. Si el tiquete aéreo contiene algún error, la aerolínea podría no permitirle el embarque. La
                Agencia no se hace responsable por errores y/o inconsistencias en los datos personales ingresado por los
                Usuarios en el Sitio web.
              </li>
              <li>
                {' '}
                Corrección de errores involuntarios en tiquetes emitidos. La agencia informa que de acuerdo con lo
                dispuesto en la Resolución 2466 de 2015, proferida por la Aeronáutica Civil Colombiana, la Agencia le
                informa a los Usuarios que en caso de incurrir en un error en la información correspondiente a sus datos
                personales, entendiendo estos últimos, de manera exclusiva, como nombre (s) y/o apellido (s)
                &nbsp;contenidos en el tiquete aéreo expedido, el pasajero podrá comunicarlo a la aerolínea directamente
                o a la Agencia, quien realizará las gestiones de presentación y seguimiento de su solicitud ante la
                aerolínea emisora del tiquete, con el fin de que esta última proceda con su corrección inmediata. De
                conformidad con lo dispuesto en el artículo 3.10.1.10 de la referida Resolución, la corrección que se
                haga podrá generar un pago adicional fijo, cuyo monto no podrá ser superior al vigente para la tarifa
                administrativa aplicable al tiquete, al momento de la corrección.
                <br /> Es pertinente precisar que la misma normativa señala expresamente que en ningún caso la
                corrección de datos podrá derivar en un cambio de pasajero. &nbsp;Recuerde que, en cualquier evento,
                incluido este, la decisión final será del proveedor del servicio aéreo. Reiteramos que, la forma de
                proceder y las condiciones especiales que rigen para casos de cambios o cancelaciones en una reserva
                confirmada por el Usuario, son determinadas por las aerolíneas, quienes podrán establecer multas o
                penalidades unilateralmente, precisando, en cualquier caso, estas deberán ajustarse a la normativa
                colombiana vigente.
              </li>
              <li>
                {' '}
                Equipaje. Las Compañías Aéreas tienen diferentes políticas de franquicia de equipaje. Lo usual en los
                vuelos nacionales es de 8 kg y en los internacionales de 20/30 kg según la empresa y la clase en que se
                viaje, algunas tarifas no incluyen franquicia de equipaje. Infórmese antes de viajar. La Agencia no se
                responsabiliza por robo y/o hurto y/o pérdida de equipaje y demás efectos personales de los pasajeros.
                En caso de pérdida o deterioro de equipaje, el pasajero debe dirigirse a las oficinas de atención al
                cliente de la aerolínea y realizar el correspondiente reclamo. En todo caso, la Agencia le recomienda
                contratar un seguro de viaje para cubrir en parte este tipo de riesgos.
              </li>
              <li>
                {' '}
                Condiciones de salud. Si el pasajero presenta alguna condición de salud particular (embarazadas,
                condiciones médicas especiales) la aerolínea le exigirá una constancia de apto médico que le permita
                realizar el viaje. La misma debe tener una fecha de emisión no superior a 12 horas a la salida del
                vuelo. Tenga presente que no podrán viajar solos (ni con servicio de acompañante) personas que no puedan
                valerse por sí solas y/o que no estén en capacidad de seguir instrucciones.
              </li>
              <li>
                Tiquetes solo ida. Tenga en cuenta que por disposiciones migratorias de cada país, en caso de ser no
                residente del país de destino y contratar a través de nuestra plataforma un tiquete aéreo únicamente de
                ida, el pasajero podrá ser requerido por las autoridades migratorias a justificar las razones por las
                que no cuenta con un tiquete aéreo de regreso. La Agencia le recomienda consultar al Consulado o
                Embajada correspondiente antes de efectuar la reserva de solo ida. Las aerolíneas también podrán exigir
                esta documentación antes de permitir el embarque.
              </li>
              <li>
                {' '}
                Responsabilidad de las aerolíneas. La responsabilidad de las aerolíneas por el transporte de las
                personas y sus equipajes se encuentra regulada por la Normativa Aeronáutica. Si el Usuario y/o pasajero
                desea realizar un reclamo respecto del contrato de transporte aéreo celebrado, el Usuario puede
                efectuarlo ante la Aeronáutica Civil Colombiana en la página web www.aerocivil.gov.co, organismo
                encargado de regular, vigilar, fiscalizar y certificar la actividad aeronáutica comercial en Colombia.
              </li>
              <li>
                {' '}
                Aceptación de términos y condiciones. El Usuario debe aceptar que ha leído y está de acuerdo con todos
                los términos de compra del tiquete aéreo. Una vez terminado el proceso usted recibirá dos correos
                electrónicos: uno de confirmación automática de la plataforma de pago y otro de la confirmación de su
                tiquete aéreo.
              </li>
              <li>
                {' '}
                Duplicidad. Absténgase de generar más de una reserva para el mismo destino- pasajero- fecha - hora y
                aerolínea, esto se considera una mala práctica de duplicidad que puede ocasionar una cancelación de
                reserva por parte de la aerolínea.
              </li>
              <li>
                Servicios especiales. Son aquellos servicios que se brindan a los pasajeros de acuerdo con sus
                necesidades o requerimientos individuales y deben ser solicitados por el usuario ante la Agencia de
                Viajes con una antelación no menor a 72 horas de la fecha del vuelo, éstos servicios se encuentran
                sujetos a confirmación por parte de las aerolíneas de acuerdo con la disponibilidad y en algunas
                ocasiones pueden generar costo a cargo exclusivo del Usuario o pasajero. Estos servicios pueden ser
                entre otros, transporte de menores, menores sin acompañante, requerimiento de sillas de ruedas, comidas
                especiales, transporte de mascotas, servicios de transporte para pasajeros enfermos, ente otros.
              </li>
              <li>
                Transporte de menores. Para efectos del servicio de transporte aéreo se considera menor a la persona que
                no ha cumplido los 12 años de edad a la fecha del vuelo.&nbsp;Infante: Es el menor que a la fecha del
                vuelo no ha cumplido 2 años de edad y viaja sin ocupar asiento, acompañado de un adulto responsable. El
                infante viajará en el regazo del adulto responsable. El infante requiere&nbsp; de&nbsp; un&nbsp;
                boleto&nbsp; de&nbsp; transporte&nbsp; aéreo&nbsp; aun&nbsp; cuando&nbsp; no&nbsp; esté pagando una
                tarifa. Si el adulto responsable desea que el&nbsp;infante ocupe un asiento deberá pagar el costo del
                boleto de transporte aéreo y deberá llevar una silla de infante aprobada por las normas internacionales
                como apta para usarse en una aeronave. Niño: Es el menor que habiendo cumplido los 2 años de edad no ha
                cumplido los 12 años a la fecha del vuelo y deberá viajar ocupando un asiento y pagando la tarifa
                correspondiente.
              </li>
              <li>
                {' '}
                Menores sin acompañante. Se define este servicio como el transporte de un menor que a la fecha del viaje
                tiene cinco (5) años cumplidos y no ha llegado a cumplir los doce (12) años y viaja bajo&nbsp;la
                custodia de un funcionario del transportador. El servicio es opcional para menores entre doce&nbsp;(12)
                y diecisiete (17) años cumplidos en vuelos regulares domésticos. Las restricciones en la prestación del
                servicio se pueden consultar en el contrato de transporte de la aerolínea o en su defecto podrán ser
                consultadas en el link contrato de transporte de las aerolíneas ubicado en la parte inferior de la
                página este Sitio web.
              </li>
              <li>
                {' '}
                Documentación para menores. De acuerdo a lo establecido en el artículo 110 del Código de Infancia y
                Adolescencia modificado por el artículo&nbsp;9 de la Ley 1878 de 2018, la agencia informa “Cuando un
                niño, una niña o un adolescente que tiene residencia en Colombia vaya a salir del país con uno de los
                padres o con una persona distinta a los representantes legales deberá obtener previamente el permiso de
                aquel con quien no viajare o el de aquellos, debidamente autenticado ante notario o autoridad consular.
                Dicho permiso deberá contener el lugar de destino, el propósito del viaje y la fecha de salida e ingreso
                de nuevo al país.”
                <br /> En caso de realizar un viaje al extranjero con menores de edad, la Agencia le recomienda al
                Usuario verificar si los menores de edad que viajan cuentan con el nuevo pasaporte, en este caso el
                adulto responsable deberá presentar ante las Autoridades de Migración en Colombia, fotocopia auténtica y
                legible del registro civil de nacimiento.
                <br /> En cumplimiento de lo establecido por la Unidad Administrativa Especial de la Aeronáutica Civil
                (UAEAC), la Agencia le informa al usuario que en los vuelos nacionales la presentación de la&nbsp;copia
                del original&nbsp;del Registro Civil de los menores de 0 a 7 años al momento de viajar por modo aéreo es
                obligatorio, de lo contrario,&nbsp;los menores no podrán viajar&nbsp;a destinos nacionales.&nbsp;
              </li>
            </ul>
            <h3>3.2 Hoteles</h3>
            <ul>
              <li>
                {' '}
                Funcionalidad. El Sitio web le permite al Usuario realizar una reserva y la misma se debe garantizar y
                pagar con tarjeta de crédito, éste medio de pago será validado directamente por un sistema de pago en
                línea, en caso de detectar alguna inconsistencia en la misma, la reserva puede ser cancelada.
              </li>
              <li>
                {' '}
                Cargos. El valor total del alojamiento será liquidado y cargado a la tarjeta de crédito o al medio de
                pago utilizado en el momento de cerrar la reserva.
              </li>
              <li>
                {' '}
                Reservas. Es importante que verifique la acomodación, las condiciones específicas de la reserva hotelera
                y los servicios incluidos en el precio informado. Los servicios adicionales, tasas y seguro hotelero
                optativo serán liquidados y deberán ser pagados directamente en el hotel. Si viaja con menores el
                Usuario deberá incluirlo en la reserva, asi no ocupe cama, existen alojamientos que no aceptan menores.
              </li>
              <li>
                {' '}
                Cancelación o exceso de reservas del alojamiento. La Agencia ofrece los Alojamientos en su Plataforma
                según la disponibilidad informada por los Proveedores a través de un sistema informático de reservas. En
                ningún caso la Agencia ofrecerá un Alojamiento que no otorgue disponibilidad en el sistema. Sin
                perjuicio de ello, tenga presente que el&nbsp;overbooking&nbsp;es una práctica habitual en el mercado
                turístico y, en algunos países, esta práctica se encuentra regulada. El&nbsp;overbooking&nbsp;puede
                suceder también por fallos en los sistemas de reservas o fallos humanos. En el caso de que un
                Alojamiento no pueda respetar su reserva en las condiciones contratadas, el Alojamiento deberá
                proporcionarle, a su costo, un alojamiento/habitación alternativo/a de calidad igual o superior a la
                reservada por el Usuario originalmente. La Agencia, en su carácter de intermediario, hará sus mejores
                esfuerzos para que el Usuario pueda disfrutar de su estadía sin inconvenientes.
              </li>
              <li>
                {' '}
                Políticas. No olvide verificar las políticas de cancelación y condiciones de la tarifa del hotel que
                está reservando.
              </li>
              <li>
                {' '}
                Horarios de check-in y check-out.&nbsp;Sin perjuicio de los horarios informados para cada Alojamiento en
                el Sitio web, la cantidad prevista de días de alojamiento se computa desde el horario de check-in y
                finaliza en el horario de check-out del día siguiente, independientemente de la hora de llegada y/o de
                salida, y de la utilización completa o fraccionada del mismo. El Usuario debe tener presente que los
                horarios que se reflejan en el voucher están expresados en horario local del lugar de destino.
              </li>
              <li>
                {' '}
                Régimen&nbsp;de responsabilidad&nbsp;de alojamientos, Le informamos que la actividad de los Alojamientos
                domiciliados en la República de Colombia, se encuentra regida por un conjunto de normas, entre ellas,
                Ley 1480 de 2011, Ley 300 de 1996 (Ley General del Turismo), y sus decretos reglamentarios, además de
                las disposiciones especiales establecidas por el Ministerio de Comercio, Industria y Turismo y demás
                autoridades regulatorias y de defensa del consumidor Colombiano. Si el Usuario desea realizar un reclamo
                respecto del servicio brindado por el Alojamiento, puede efectuarlo directamente ante los organismos
                previamente expuestos, para esto, puede ingresar
                a:&nbsp;www.mincit.gov.co/&nbsp;y/o&nbsp;www.sic.gov.co.
              </li>
              <li>
                Los extranjeros no residentes en Colombia están exentos de tasas/impuestos hoteleros en Colombia
                acreditando el ingreso al país en un periodo no mayor a 30 días al momento de registrarse en el hotel y
                solo tendrán que pagar el seguro hotelero optativo, en caso de quererlo directamente en su hotel. Los
                pasajeros colombianos deben pagar en su hotel directamente las tasas y el seguro hotelero optativo en
                caso de contratarlo. Esta validación se realizara directamente en el hotel.
              </li>
            </ul>
            <h3>3.2 Renta de vehículo</h3>
            <ul>
              <li>
                {' '}
                Reserva de autos. Cada empresa “Rentadora” de autos tiene sus propias regulaciones del servicio y
                tarifarias aplicables al alquiler de vehículos. La Agencia garantiza que el precio informado en el sitio
                web para el alquiler de Autos incluye la renta del auto por un período determinado, el kilometraje
                mencionado en cada caso y la totalidad de los requisitos y seguros mínimos requeridos para retirar el
                Auto y transitar legalmente en el destino elegido, sin contratar seguros ni elementos adicionales. La
                tarifa de renta no incluye el pago de multas, infracciones, arrastre de grúas, gasolina, dejar el auto
                en otra ciudad, ni cualquier otro servicio adicional.
              </li>
              <li>
                {' '}
                Información de autos. La reserva generada a través del sitio web, asegura una clase de Autos, y no para
                vehículos de marcas, años o modelos específicos, ni de características especiales que no sean comunes a
                todos los vehículos de la clase. La Rentadora garantiza el tamaño y capacidad del Auto, sin embargo la
                marca y modelo de los vehículos están sujetos a disponibilidad y ubicación.
              </li>
              <li>
                {' '}
                Solicitud de cancelación o cambios. De acuerdo a lo establecido por cada Rentadora, el Usuario podrá
                adquirir reservas reembolsables y no reembolsables. En el caso de que la reserva adquirida permita
                reembolso, la reserva podrá ser cancelada en cualquier momento, siempre que el Usuario notifique a la
                Agencia y/o a la Rentadora su voluntad en ese sentido con al menos 24 horas de antelación al retiro del
                Auto. Pasado ese plazo no podrán efectuarse reembolsos. En caso de proceder, los reembolsos la Agencia
                gestionará la solicitud de reembolso ante la rentadora, y podrán demorar entre 30 y 45 días hábiles
                hasta su efectiva acreditación.
              </li>
              <li>
                {' '}
                Condiciones particulares del alquiler de auto. Los períodos de alquiler se calculan en bloques de 24
                horas. La duración del alquiler comienza y termina en las fechas que se especifican en el voucher. En
                los eventos en que el Auto fuera retirado o entregado fuera de horas de oficina o por fuera de las horas
                o lugares pactados en el momento de la reserva, la Rentadora podrá cobrar cargos adicionales que deberán
                ser asumidos por el Usuario.{' '}
              </li>
              <li>
                {' '}
                Documentos mínimos. Cuando el Usuario se presente ante la Rentadora deberá presentar: (i) el voucher de
                servicio enviado por la Agencia; (ii) un permiso de conducción vigente, válido en el lugar de destino y
                expedido con una antigüedad mínima de dos años; y (iii) una tarjeta de crédito internacional con cupo
                suficiente para garantizar la reserva. En algunos casos puede requerirse el pasaporte. En algunos
                destinos internacionales le podrán exigir al Usuario, la presentación de una licencia internacional e
                interamericana de conducir. Esta situación se presenta cuando el conductor se encuentra involucrado en
                problemas de tránsito o para acreditar la condición de conductor extranjero ante las autoridades de
                tránsito.
              </li>
              <li>
                {' '}
                Garantía. El Usuario deberá presentar de manera obligatoria una tarjeta de crédito internacional a
                nombre del conductor al momento de retirar el Auto. En la misma, la Rentadora realizará el bloqueo de
                cupo del monto correspondiente a la franquicia a modo de garantía, la cual podrá ser de hasta el doble
                de la tarifa abonada por el alquiler del Auto.
              </li>
              <li>
                {' '}
                Cargos adicionales. le hacemos saber que durante el desarrollo del período locativo, se podrían generar
                cargos o débitos a su cargo no reclamados por la Rentadora en forma inmediata (como multas por
                infracciones de tránsito o daños, roturas o faltantes sufridos por el Auto). El Usuario se compromete a
                abonar dichas multas y cargos adicionales cuando le sean reclamados por la Rentadora. Estos cargos
                adicionales dependen de las políticas de cada Rentadora y son cobrados directamente por ésta sin
                intervención ni injerencia alguna de la Agencia.
              </li>
              <li>
                {' '}
                Seguros y servicios adicionales contratados en destino. En destino la Rentadora podría ofrecerle
                contratar servicios adicionales (tales como seguros con pólizas de mayor cobertura, cuota de
                recuperación de, cargo por gasolina, cargo por conductor adicional, GPS, asientos para menores, etc),
                los que serán contratados directamente por Usted y cobrados por la Rentadora sin intervención de la
                Agencia. La contratación de tales adicionales es voluntaria y ajena a la Agencia quien no es responsable
                por los valores que el Usuario deba abonar por tales conceptos.
              </li>
              <li>
                {' '}
                Peaje. En ciertas jurisdicciones el Usuario podrá contratar directamente con la Rentadora un servicio de
                telepeaje, que le permitirá trasladarse cómodamente y evitar multas. Ese servicio podrá ser libremente
                contratado por el Usuario directamente a la Rentadora. La Agencia reitera que no se hace responsable por
                tales conceptos y valores.
              </li>
              <li>
                {' '}
                Conductores menores de 26 años. En algunos destinos, las Rentadoras tienen políticas para conductores
                con edades entre 21 y 26 años, en las cuales podrán regir restricciones y/o cargos adicionales que
                deberán abonarse en destino. Dichos cargos no se encuentran incluidos en la tarifa.
              </li>
              <li>
                {' '}
                Jurisdicción. Si el Usuario planea cruzar una frontera estatal, asegúrese antes de completar la
                Solicitud de Compra que el Auto esté autorizado para transitar por tal destino. Algunas Rentadoras
                pueden prohibir o cobrar un adicional por transitar en una jurisdicción extraña. Revise las condiciones
                de la Rentadora en ese aspecto.{' '}
              </li>
              <li>
                {' '}
                Régimen de responsabilidad. Para este servicio es aplicable a la renta de autos, le informamos que la
                actividad de intermediación de la Agencia, en lo referente al alquiler o renta de Automóviles, en la
                República de Colombia, está regulada por varias normas, el Código Civil, Código de Comercio, Ley 1480 de
                2011, Ley 300 de 1996, y sus decretos reglamentarios, además de las disposiciones especiales
                establecidas por el Ministerio de Comercio, Industria y Turismo y las demás autoridades regulatorias,
                como la Superintendencia de Industria y Comercio Colombiana.
              </li>
            </ul>
            <h3>3.4 Tiquetes de Transporte Terrestre</h3>
            <ul>
              <li>
                Antelación para el viaje. El Usuario o pasajero debe presentarse en el lugar indicado para la salida del
                bus, con la antelación indicada por el prestador de servicios de transporte terrestre. Por regla
                general, en el caso de transporte terrestre, la antelación mínima es de una (1) hora sobre el horario de
                salida previsto. En caso de no presentarse con la antelación requerida se aplicará lo que se contempla
                más adelante bajo el ítem de “Desistimiento del Usuario/pasajero”.
              </li>
              <li>
                Equipaje. El Usuario o pasajero es responsable de la pérdida o daño del equipaje, pertenecías u objetos
                que tiene bajo su custodia.
              </li>
              <li>
                {' '}
                Itinerarios y buses para prestación del servicio. El prestador de servicios de transporte terrestre se
                compromete a hacer todo lo posible para transportar al pasajero y equipaje con celeridad razonable. Las
                horas de salida y llegada señaladas en los horarios de la sección “seleccionar viaje” o en cualquier
                otra parte, son meramente ilustrativos, razón por la cual no se garantizan ni forman parte de la
                pre-reserva, ni del contrato de transporte con el operador o prestador de servicios, por la naturaleza
                propia del servicio de transporte en el territorio.
                <br /> En caso de que así sea necesario, y sin previo aviso, el transportista puede hacerse sustituir
                por otros transportistas y/o utilizar otros buses, con servicios adicionales distintos a los ilustrados,
                incluso de otras compañías. Los horarios están sujetos a modificación sin previo aviso.
              </li>
              <li>
                {' '}
                Modificaciones o cambios por parte del proveedor del servicio. El prestador de servicios de transporte
                terrestre podrá realizar los cambios que sean necesarios para el buen fin del viaje y que no sean
                significativos. Se considera que los cambios necesarios son significativos si impiden la realización
                total del viaje.
                <br /> En el supuesto de que el prestador de servicios de transporte terrestre se vea obligado a
                realizar cambios significativos, lo pondrá inmediatamente en conocimiento del pasajero, quien podrá
                aceptar la modificación del contrato en el cual se precisan los cambios introducidos y su repercusión en
                el precio, o desistir del contrato. El pasajero deberá comunicar la decisión tomada al prestador de
                servicios de transporte terrestre dentro de los cinco (5) días siguientes desde que se notifica la
                modificación. Si el pasajero no comunica su decisión en el plazo indicado, se entenderá que opta por
                desistir del mismo.
              </li>
              <li>
                {' '}
                Modificaciones o cambios por Usuario/pasajero. El Usuario podrá solicitar cambios o modificaciones antes
                de la fecha de salida, los cuales se encuentran sujetos a la disponibilidad del prestador de servicios,
                en cuyo caso el prestador de servicios podrá cobrar gastos adicionales por la modificación de la
                reserva, cada empresa establece dichos costos a su discreción, sin que la Agencia tenga responsabilidad
                sobre dichos gastos.
              </li>
              <li>
                {' '}
                Incumplimiento por fuerza mayor. La Agencia no se responsabiliza por el incumplimiento de las empresas
                de servicio de transporte terrestre&nbsp; en la ejecución de sus obligaciones, asuntos o hechos de
                fuerza mayor, caso fortuito o eventos tales como modificaciones unilaterales, huelgas, condiciones
                climáticas, atrasos, cierres de vías causados por la autoridad o por terceros, terremotos, asuntos de
                salubridad, condiciones de seguridad, factores políticos, negación de permisos de ingreso, retiro del
                viajero por conductas que atenten contra la realización del viaje, ni como por los perjuicios
                materiales, personales o morales que pueda sufrir el pasajero por pérdida, daño o hurto de equipaje, ni
                por accidentes, enfermedades o fallecimientos, casos enunciados a manera de ejemplo. En caso de
                prestarse cualquiera de estas situaciones, el Usuario deberá reclamar directamente ante las empresas
                prestadoras del servicio incumplido.
              </li>
              <li>
                {' '}
                Derecho de Retracto. Los usuarios podrán ejercer el derecho de retracto frente a las compras realizadas
                en el Sitio Web de acuerdo a lo establecido en el artículo 47 de la ley 1480 de 2011, el término máximo
                para ejercer el derecho de retracto será de cinco (5) días hábiles contados a partir del día en que se
                realizó la compra, siempre y cuando no haya comenzado a prestarse el servicio antes de cinco (5) días.
                Para ejercer el derecho de retracto, el Usuario deberá informar su decisión a través de nuestra línea de
                atención al cliente en horarios de oficina de Lunes a viernes de 8 am a 5pm y/o en la página web
                ingresando todos los datos en el formato de Modificaciones, cambios y cancelaciones ubicado en un link
                en la parte inferior de este Sitio Web.
              </li>
              <li>
                {' '}
                Desistimiento del Usuario/pasajero. Aplica en los siguientes eventos (i) si el Usuario no comunica su
                voluntad de no llevar a cabo el viaje y no se presenta en el tiempo y lugar previstos para la salida. En
                este caso, pierde el derecho a la devolución de las cantidades entregadas y continúa obligado a abonar
                las que estuvieran pendientes de pago. (ii) si la falta de presentación tiene lugar por causa de fuerza
                mayor (por muerte, el accidente o enfermedad graves del pasajero o de alguna de las personas con quien
                conviva o cualquier supuesto análogo que le impida participar en el viaje y comunicar a la agencia esa
                imposibilidad antes de la salida), en estos casos el Usuario tendrá derecho a aportar la documentación
                que justifique la causal, la cual será evaluada por el prestador del servicios de trasporte terrestre,
                quien autorizará que se le devuelvan las cantidades entregadas, descontando los gastos de gestión y los
                gastos de anulación.
              </li>
              <li>
                Responsabilidad de la Agencia y el prestador de servicios. Se definen de la siguiente manera. (i) La
                Agencia y el prestador de servicios se obligan a responder frente al pasajero del correcto cumplimiento
                del contrato de viaje en función de las obligaciones que les correspondan por su ámbito respectivo de
                gestión del viaje. (ii)El prestador de servicios de transporte terrestre responde de los daños causados
                al pasajero por la no ejecución o ejecución deficiente de las prestaciones comprendidas en el viaje, así
                como de los daños que procedan del incumplimiento de cualquier otra obligación que corresponda a su
                ámbito de gestión de acuerdo con la legislación aplicable.(iii) La Agencia facilita el canal de venta
                obrando como intermediario de la venta del viaje propuesto por el prestador de servicios de transporte
                terrestre, responde de los daños causados al pasajero por los errores que haya cometido al informarle
                sobre el viaje, por haber omitido la información que debía proporcionarle y, en general, por haber
                incumplido cualquier otra obligación que corresponda a su ámbito de gestión del viaje. En este sentido
                la Agencia cumple funciones de intermediación entre el cliente y el prestador de servicio de transporte
                terrestre, por lo que se le exime de cualquier responsabilidad debido a cancelaciones, cambios de
                horario, prestación deficiente, entre otras, por parte del prestador de servicios de transporte
                terrestre.
              </li>
              <li>
                {' '}
                Causales de exoneración de responsabilidad. (i) Por defectos observados en la ejecución del contrato
                sean imputables al pasajero. (ii) Que dichos defectos sean imputables a un tercero ajeno al suministro
                de las prestaciones previstas en el contrato y revistan un carácter imprevisible o insuperable. (iii)
                Que los defectos aludidos se deban a motivos de fuerza mayor, entendiendo por tales aquellas
                circunstancias ajenas a quien las invoca, anormales e imprevisibles cuyas consecuencias no habrían
                podido evitarse, a pesar de haber actuado con la diligencia debida. (iv) Que los defectos se deban a un
                acontecimiento que&nbsp;la Agencia&nbsp;o el prestador de servicios de transporte terrestre a pesar de
                haber puesto toda la diligencia necesaria, no podía prever ni superar.
              </li>
            </ul>
            <h3> 4. Uso Autorizado</h3>
            <p>
              La Agencia es propietaria del Sitio y posee las autorizaciones correspondientes para el uso de los
              contenidospublicados, así como de las codificaciones implementadas en el Sitio. Cualquier modificación,
              alteración, uso delsoftware, imagen corporativa, logotipos, enlaces entre sitios web deberán estar
              autorizado expresamente y de formaescrita por La Agencia.
              <br />
              Este Sitio Web ha sido diseñado única y exclusivamente para su uso personal. Es prohibido comercializar
              elcontenido, productos, información, software y servicios obtenidos de éste Sitio.{' '}
            </p>
            <h3>5. portafolio de servicios</h3>
            <p>
              Recuerde verificar los términos y condiciones por servicio o producto, los cuales se pueden aplicar a las
              reservaciones, compra de bienes y servicios y a otras secciones de este sitio, según el proveedor de
              servicios específicos y que usted en calidad de Usuario manifiesta aceptar dichas cláusulas.
            </p>
            <h3>6.Publicidad</h3>
            <p>
              Parte del Sitio puede albergar contenidos publicitarios o estar patrocinado. Los anunciantes y
              patrocinadores son los únicos responsables de asegurarse que el material remitido para su inclusión en el
              Sitio cumple con las leyes que en cada caso puedan ser de aplicación. La Agencia no será responsable de
              cualquier error, inexactitud o irregularidad que puedan contener los contenidos publicitarios o de los
              patrocinadores.
            </p>
            <h3>7.Conexiones y enlaces con terceros portales.</h3>
            <p>
              Este Sitio web puede contener enlaces (vínculos) que comuniquen con portales operados por terceros
              independientesdel sitio web de la Agencia de Viajes.La Agencia de Viajes no tiene ningún control sobre los
              mismos y no se responsabiliza de sus contenidos. Lainclusión de estos sitios en el sitio web de la Agencia
              de Viajes, no implica ningún tipo de asociación con dichasterceras partes ni sus operadores.
              <br />
              Este Sitio Web tiene conexiones con otros sitios web, por favor tenga en cuentaque cuando usted entra en
              uno de estos enlaces, usted está entrando en un portal ajeno al sitio en internet deesta Agencia de Viajes
              y éste, no tiene por tanto, ninguna responsabilidad. Se aconseja que lea las instruccionesde dichos sitios
              sobre la privacidad de los mismos, ya que estas pueden ser diferentes de las ofrecidas por estaAgencia de
              Viajes.
            </p>
            <h3>8. Sistemas de Distribución Global</h3>
            <p>
              La información suministrada en nuestro Sitio web referente a los horarios, disponibilidad y reservas en
              línea deautos, hoteles y vuelos son propiedad de los sistemas de distribución global (GDS). Este Sitio se
              ha creado condatos obtenidos de varias fuentes.&nbsp; No se garantiza la disponibilidad, acceso,
              veracidad, puntualidad ni ningúnotro aspecto de la información en él contenida.
            </p>
            <h3>9. Seguridad y privacidad</h3>
            <p>
              {' '}
              La información que usted suministra en nuestro sitio se encuentra protegida por sistemas de seguridad
              probados y altamente confiables.
            </p>
            <h3>9.1 Riesgos de Seguridad que debe tener en cuenta cuando realiza transacciones en Internet</h3>
            <ul>
              <li>
                {' '}
                Se puede presentar que un usuario sea engañado por medio de correos electrónicos o algún engaño de
                servidores DNS, para visitar un sitio falso que presente el mismo diseño, pero donde los datos de la
                tarjeta sean cargados en el sistema falso, robando información del tarjeta habiente. Por lo cual es
                importante generar la cultura, que los usuarios para realizar transacciones deben entrar directamente
                por los dominios conocidos para disminuir los riesgos.
              </li>
              <li>
                {' '}
                Se puede presentar que el computador donde el usuario este realizando la transacción, tenga instalado
                sin conocimiento previo del usuario algún software espía o mal intencionado que capture todo lo digitado
                por el teclado o capture información de dispositivos de entrada y sean enviados a alguna red o host en
                internet. Por lo anterior se recomienda en lo posible que la transacción sea realiza en el computador de
                la casa o la oficina.{' '}
              </li>
              <li>
                {' '}
                Se podría presentar suplantación del usuario o que el usuario se niegue&nbsp;haberlo enviado y/o
                recibido la transacción y sea utilizada por un tercero.
              </li>
            </ul>
            <h3>10. Autorización habeas data.</h3>
            <p>
              Al registrar sus datos en nuestro portal web con el fin de realizar una compra, usted autoriza a
              NetacticaColombia SAS sociedad debidamente constituida y existente bajo las leyes de la República de
              Colombia, identificadacon Nit. No. 900132867-1, para que directamente y/o a través de su unidad de
              negocios Netviajes, sus empleados,directores y/o proveedores de servicios financieros recolecten,
              almacenen, administren, procesen, transfieran,transmitan, supriman, usen y/o de cualquier manera realicen
              operaciones sobre cualquier información que pueda serrelacionada directa o indirectamente con usted (los
              “Datos Personales”) que usted suministre a través del portalweb y/o que le solicitemos de tiempo en tiempo
              y para que reporten información del comportamiento crediticio,financiero, comercial y de servicios a
              terceros y a la central de información CIFIN S.A, o entidades homólogas enotros países, generándose una
              huella de consulta. Esta autorización comprende la facultad para Netviajes detransmitir o transferir sus
              datos, incluidos aquellos que pueden ser datos sensibles dentro o fuera del territoriocolombiano,
              independientemente del nivel de protección que ostente el país receptor. A través del portal
              websolicitaremos Datos Personales como nombre y apellidos, fecha de nacimiento, correo electrónico y
              cualquier otroDato Personal que sea informado en la Política de Privacidad.{' '}
            </p>
            <p>
              Los Datos Personales suministrados en el portal web serán procesados con el propósito de procesar,
              confirmar ycumplir con los servicios adquiridos, así como para la realización de la reserva,
              modificaciones, cancelaciones ycambios de itinerario, reembolsos, atención de consultas, quejas y
              reclamos, pago de compensaciones eindemnizaciones, registros contables, correspondencia, procesamiento y
              verificación de tarjetas de crédito, débitoy otros instrumentos de pago, promocionar y publicitar nuestras
              actividades, productos y servicios, realizartransacciones financieras de pagos, cobros o reembolsos,
              atender procedimientos legales, efectuar reportes oatender requerimientos de las distintas autoridades
              administrativas de control y vigilancia nacionales ointernacionales, autoridades de policía o autoridades
              judiciales, entidades bancarias y/o compañías aseguradoras,para fines administrativos internos y/o
              comerciales, incluyendo investigación de mercados, auditorías, reportescontables, análisis estadísticos,
              facturación, y ofrecimiento y/o reconocimiento de beneficios a través deprogramas de fidelización, para la
              ejecución del contrato de transporte y demás servicios y actividadescomplementarias, identificación de
              fraudes y prevención de lavado de activos y de otras actividades delictivas y/opara el funcionamiento de
              los programas de fidelización.{' '}
            </p>
            <p>
              Al aceptar estos Términos y Condiciones y registrar sus Datos Personales en nuestro portal web reconoce
              que hasido informado de sus derechos respecto de los mismos. Para conocer más sobre sus derechos a (i)
              conocer,actualizar y rectificar sus Datos Personales, (ii) solicitar prueba de la autorización, (iii)
              presentarsolicitudes, quejas o reclamos, (iv) presentar quejas por violación de la ley, (v) revocar la
              autorización ysolicitar acceso a sus Datos Personales, las formas de ejercerlos y las finalidades de
              tratamiento, lo invitamos aconsultar la Política de Privacidad. En caso de tener cualquier duda
              relacionada con sus Datos Personales porfavor comunicarse con el correo electrónico
              servicioalcliente@netviaje.co{' '}
            </p>
            <h3>
              11. Autorización para la consulta y el procesamiento de datos financieros en centrales de riesgo
              crediticio.{' '}
            </h3>
            <p>
              Con la aceptación de la presente Política de Privacidad, usted autoriza de manera expresa e irrevocable,
              libre yvoluntariamente a Netviajes o a quien represente sus derechos u ostente en el futuro a cualquier
              título la calidadde acreedor, para que reporte, consulte y divulgue a la Asociación Bancaria y de
              Entidades Financieras de ColombiaASOBANCARIA, o a cualquier otro operador y/o fuente de información
              legalmente establecido, toda la informaciónreferente a su comportamiento como cliente que se relacione con
              el nacimiento, ejecución, modificación,liquidación y/o extinción de las obligaciones que se deriven del
              presente contrato, en cualquier tiempo, y quepodrá reflejarse en las bases de datos de la CIFIN o de
              cualquier otro operador y/o fuente de informaciónlegalmente establecido. La permanencia de la información
              estará sujeta a los principios, términos y condicionesconsagrados en la ley 1266 de 2008, ley 1581 de 2012
              y demás normas que lo modifiquen, aclaren o reglamenten. Asímismo, autoriza, expresa e irrevocablemente a
              Netviajes para que consulte toda la información financiera,crediticia, comercial, de servicios y la
              proveniente de otros países, atinente a las relaciones comerciales quetenga con el Sistema Financiero,
              comercial y de servicios, o de cualquier sector, tanto en Colombia como en elExterior, en cualquier
              tiempo.{' '}
            </p>
            <p>
              La presente autorización se extiende para que Netviajes pueda compartir su información financiera con
              tercerospúblicos o privados, bien sea que éstos ostenten la condición de fuentes de información,
              operadores de informacióno usuarios, con quienes usted tenga vínculos jurídicos de cualquier naturaleza,
              todo conforme a lo establecido enla legislación vigente en Colombia en materia de protección de datos
              personales.
            </p>
            <h3>12. Contra la pornografía infantil</h3>
            <p>
              En desarrollo de lo dispuesto en el artículo 17 de la Ley 679 de 2001, la agencia advierte al turista que
              la explotación y el abuso sexual de menores de edad en el país son sancionados penal y
              administrativamente, conforme a las leyes vigentes. De igual manera, en cumplimiento a la Resolución 3840
              del 24 de diciembre de 2009 y según el Artículo 1 de la Ley 1336 del 21 de julio de 2009, Netviajes acoge
              y promueve la normatividad y legislación aplicable tanto local como internacional sobre prevención de la
              explotación, pornografía y turismo sexual con menores en el desarrollo de su actividad turística.
            </p>
          </div>
        </div>
      </>
    )}
  </>
);

export default Terms;
